import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do mortgage brokers get more direct borrowers?",
    "a": "Product-specific pages plus local SEO plus reviews. Borrowers search by product ('jumbo loan', 'VA loan', 'first-time homebuyer'). Brokers who rank for each product capture every search intent."
  },
  {
    "q": "Is SEO worth it given rate cycles?",
    "a": "Yes — purchase volume is rate-independent, and refi spikes during low-rate windows make a strong inbound pipeline even more valuable. SEO compounds across both cycles."
  },
  {
    "q": "Should brokers run Google Ads?",
    "a": "Yes — purchase and refi keywords convert profitably with proper tracking. We build campaigns with loan-product-specific landing pages."
  },
  {
    "q": "How do we compete with Rocket, UWM, and other national lenders?",
    "a": "Personal relationship, product diversity, and local market knowledge. National lenders win on scale; brokers win on service and product flexibility. The site has to make that difference obvious."
  },
  {
    "q": "Do you market specialty loans (jumbo, VA, construction, non-QM)?",
    "a": "Yes — specialty loans are higher-margin and lower-competition than conventional purchase. Specialty pages rank fast and book steady."
  }
];

export const Route = createFileRoute("/mortgage-broker-marketing-colorado")({
  head: () =>
    industryMarketingHead("Mortgage Broker", "mortgage broker", "mortgage-broker-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Mortgage Broker"}
      industryLower={"mortgage broker"}
      slug={"mortgage-broker-marketing-colorado"}
      subheadline={"We help Colorado mortgage brokers and loan officers build a steady inbound pipeline — purchase, refi, and investment — without relying on realtor referrals alone."}
      painPoints={["Realtor referrals fluctuate and your pipeline rides the rate cycle","Big lenders (Rocket, UWM) dominate every search you should win","Your site doesn't show loan products or pre-qualify the borrower"]}
      serviceDescriptions={{
        seo: "Rank for mortgage broker, home loans, refinance, FHA, VA, jumbo, and every loan product across every Colorado market.",
        googleMaps: "Own 'mortgage broker near me' in the Map Pack with rate-shop and loan-product Map Pack signals.",
        webDesign: "Product-specific pages — purchase, refi, FHA, VA, jumbo — with rate quote forms and pre-qualification flows.",
        ppc: "Profitable Google Ads tuned to purchase and refi searches with strong intent and tracking.",
        geoAi: "Get cited when borrowers ask ChatGPT 'best mortgage broker in Denver' or 'jumbo loan officer near me'.",
        socialMedia: "Educational content that builds trust and converts realtor referrals and direct borrowers.",
      }}
      testimonial={{"quote":"Inbound now drives more units than my realtor partners. The product pages and ads convert at a rate that finally makes the business predictable.","role":"Mortgage Broker","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Mortgage broker marketing in Colorado Springs","description":"Purchase and VA loan pipeline across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Mortgage broker marketing in Denver","description":"Compete with national lenders across the Denver mortgage market."},{"to":"/castle-rock-digital-marketing","label":"Mortgage broker marketing in Castle Rock","description":"Jumbo and high-net-worth lending across Castle Rock and Douglas County."}]}
    />
  ),
});
